import React from "react";
import { Card, NLinesShowMore } from "@sscs/ui";
import { DownloadIcon as FileDownloadIcon } from "@sscs/ui/icons";
import styles from "./licenseText.module.scss";
const LicenseText = ({ licenseText, fileName, }) => {
    return (React.createElement(Card.Card, null,
        React.createElement(Card.Title, { actions: React.createElement("a", { download: fileName.includes(".") ? fileName : `${fileName}.txt`, title: "Download license text", href: window.URL.createObjectURL(new Blob([licenseText], {
                    type: "text/plain",
                })), className: styles["download-license"] },
                React.createElement(FileDownloadIcon, null)) }, "License text"),
        React.createElement(Card.Content, null,
            React.createElement(NLinesShowMore, { value: React.createElement("pre", { className: styles["license-text"] }, licenseText), numberOfLines: 5 }))));
};
export default LicenseText;
//# sourceMappingURL=LicenseText.js.map